export type View = (container: HTMLElement, params: Record<string, string>, query: URLSearchParams) => Promise<void> | void;

interface Route {
  pattern: RegExp;
  keys: string[];
  view: View;
  nav: string;
}

const routes: Route[] = [];

export function route(path: string, nav: string, view: View): void {
  const keys: string[] = [];
  const pattern = new RegExp(
    `^${path.replace(/:([a-zA-Z]+)/g, (_, key: string) => {
      keys.push(key);
      return '([^/]+)';
    })}/?$`,
  );
  routes.push({ pattern, keys, view, nav });
}

export function match(pathname: string) {
  for (const candidate of routes) {
    const result = candidate.pattern.exec(pathname);
    if (!result) continue;
    const params: Record<string, string> = {};
    candidate.keys.forEach((key, i) => (params[key] = decodeURIComponent(result[i + 1]!)));
    return { route: candidate, params };
  }
  return null;
}

export function navigate(url: string, replace = false): void {
  if (replace) history.replaceState(null, '', url);
  else history.pushState(null, '', url);
  window.dispatchEvent(new Event('pma:navigate'));
}

/** Update the query string without re-rendering the view. */
export function setQuery(key: string, value: string | null): void {
  const url = new URL(location.href);
  if (value === null) url.searchParams.delete(key);
  else url.searchParams.set(key, value);
  history.replaceState(null, '', url);
}
